export default async function waitForLazyComponent(detect) {
    await new Promise((resolve) => {
        const int = setInterval(() => {
            if (detect()) {
                clearInterval(int)
                clearTimeout(to)
                resolve()
            }
        }, 10)
        const to = setTimeout(() => {
            clearInterval(int)
            clearTimeout(to)
            resolve()
        }, 3000)
    })
}
